import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";

var Cache = function () {
  /**
   * @constructor
   * @param {object} storage
   * @param {function:any} storage.getItem
   * @param {function:void} storage.setItem
   * @param {function:void} storage.removeItem
   * @param {string} key
   * @returns {cache}
   */

  /**
   * @private
   * @type {object} _storage
   */
  function Cache(storage, key) {
    _classCallCheck(this, Cache);

    this._storage = null;
    this._key = null;
    this._storage = storage;
    this._key = key;
  }
  /**
   * @public
   * @returns {any}
   */

  /**
   * @private
   * @type {string} _key
   */


  _createClass(Cache, [{
    key: "read",
    value: function read() {
      return this._storage.getItem(this._key);
    }
    /**
     * @public
     * @param {any} data
     * @returns {void}
     */

  }, {
    key: "write",
    value: function write(data) {
      return this._storage.setItem(this._key, data);
    }
    /**
     * @public
     * @returns {void}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      return this._storage.removeItem(this._key);
    }
  }]);

  return Cache;
}();

export default Cache;